export default "/images/vendor/flag-icon-css/flags/4x3/tz.svg?2218434d34c055a29fdf4ebd154fe074";